import { useCurrentUser } from "../../hooks/useCurrentUser";
import { useState, useEffect, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { IoIosArrowBack } from "react-icons/io";
import { DatePicker, MobileDatePicker } from "@mui/x-date-pickers";
import "../../App.css";
import {
  Autocomplete,
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Tooltip,
  TextareaAutosize,
  OutlinedInput,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material"
import { Checkbox } from "@mui/material";
import { useParams } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import apiSlice, {
  useFetchGetallManagersQuery,
  useFetchGetAllProjectBasedUserNameListQuery,
  useFetchGetallProjectsQuery,
  useFetchGetallUserListQuery,
  useFetchGetManagerByProjectQuery,
  useFetchUserAccessedProjectsQuery,
  useFetchuserbasedIssuesQuery,
  useFetchuserbasedTasksQuery,
  useFetchViewTaskByIDQuery,
} from "../../slice/logdetailSlice";
import { addData, filterEntities, postdatas, postResource } from "../../apis/apiService";
import { toast } from "react-toastify";
import Loader, { BtnLoader } from "./Loader";
import { format } from "date-fns";
import { ValidDailyLog } from "../ProjectModule/task/TaskLogHour";
import { useTimeLogSaved } from "../utilisation/TimeLogSavedProvider";
import dayjs from "dayjs";
import ReactQuill from "react-quill-new";
import taskImage from "../../assets/images/Header/Task.png";
import milestoneImage from "../../assets/images/Header/MilestoneIcon.png";
import issueImage from "../../assets/images/Header/issue image.png";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { skipToken } from "@reduxjs/toolkit/query";



const filter = createFilterOptions();
export const formatIssueOptions = (data) => {
  const options = [];

  // Milestone headers and their issues
  data?.milestones?.forEach((milestone) => {
    options.push({
      title: milestone.name,
      isHeader: true,
      type: "milestone",
    });

    milestone.issues?.forEach((issue) => {
      const status = (issue.current_status_name || issue.status_name || "").toUpperCase();
      if (!status.includes("CLOSED")) {
        options.push({
          ...issue,
          task_id: issue.issue_id,
          title: issue.title,
          isHeader: false,
          // type: "issue",
        });
      }
    });
  });

  // No milestone section (no image for this)
  if (data?.no_milestone_issues?.length) {
    options.push({
      title: "Issues",
      isHeader: true,
      type: "issue",
    });

    data.no_milestone_issues.forEach((issue) => {
      const status = (issue.current_status_name || issue.status_name || "").toUpperCase();
      if (!status.includes("CLOSED")) {
        options.push({
          ...issue,
          task_id: issue.issue_id,
          title: issue.title,
          isHeader: false,
          // type: "issue", // still treat as issue
        });
      }
    });
  }

  return options;
};

export const formatTaskOptions = (data) => {
  const options = [];

  // Format task_lists
  if (data?.task_lists) {
    data.task_lists.forEach((list) => {
      options.push({
        title: list.title,
        isHeader: true,
        type: "task_list",
      });

      list.tasks.forEach((task) => {
        const status = (task.current_status_name || task.status_name || "").toUpperCase();
        if (!status.includes("CLOSED")) {
          options.push({
            title: task.title,
            task_id: task.task_id,
            isHeader: false,
            // type: "task",
          });
        }
      });
    });
  }

  // Format milestones → task_lists
  if (data?.milestones) {
    data.milestones.forEach((milestone) => {
      milestone.task_lists.forEach((list) => {
        options.push({
          title: `${milestone.name} / ${list.task_list_name}`,
          isHeader: true,
          type: "milestone",
        });

        list.tasks.forEach((task) => {
          const status = (task.current_status_name || task.status_name || "").toUpperCase();
          if (!status.includes("CLOSED")) {
            options.push({
              title: task.title,
              task_id: task.task_id,
              isHeader: false,
            });
          }
        });
      });
    });
  }

  return options;
};

export const customFilterOptions = (options, state) => {
  const filtered = filter(
    options.filter((o) => !o.isHeader),
    state,
  );

  const result = [];

  let currentHeader = null;

  for (const option of options) {
    if (option.isHeader) {
      currentHeader = option;
    } else if (filtered.includes(option)) {
      // If this is the first task/issue under a header, push the header first
      if (!result.includes(currentHeader)) {
        result.push(currentHeader);
      }
      result.push(option);
    }
  }

  return result;
};
export const CommonAddLogHours = ({
  onApply,
  onClear,
  onCancel,
  span,
  fromDate,
  toDate,
  refetchList,
  isModule,
  isDetail,
  TaskOrIssueId,
  isTaskOrIssue,
  prefillData,
  updatePath,
  hideGeneralLog,
  onAddAnother,
}) => {
  const { notifyTimeLogSaved } = useTimeLogSaved();
  const hourOptions = Array.from({ length: 12 }, (_, i) =>
    (i + 1).toString().padStart(2, "0"),
  );
  const [selectedHour, setSelectedHour] = useState(hourOptions[0]);
  const [selectedEndHour, setSelectedEndHour] = useState(hourOptions[0]);

  const minutesOptions = Array.from({ length: 60 }, (_, i) =>
    i.toString().padStart(2, "0"),
  );

  const [selectedMinutes, setSelectedMinutes] = useState(minutesOptions[0]);
  const [selectedEndMinute, setSelectedEndMinute] = useState(minutesOptions[0]);
  // State  with "AM" "PM"
  const amPmOptions = ["AM", "PM"];
  const project_id = localStorage.getItem("project_id");
  const [showDailyLog, setShowDailyLog] = useState(false);
  const [selectedAmPm, setSelectedAmPm] = useState(amPmOptions[0]);
  const [selectedEndAmPm, setSelectedEndAmPm] = useState(amPmOptions[0]);
  const [fullTimeLog, setFullTimeLog] = useState("");
  const dateInputRef = useRef(null);
  const [taskOrIssue, setTaskOrIssue] = useState("task");
  const [selectedProjectId, setSelectedProjectId] = useState(
    isModule ? null : project_id,
  );

  const radioRef = useRef(null);
  const fullTimeRef = useRef(null);
  const currentDate = dayjs();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [selectedID, setSelectedID] = useState();
  const [showGenaralLog, setShowGenaralLog] = useState(false);
  const { id: login_user_id, name: login_user_name } = useCurrentUser();
  //console.log("add log hours id", id);
  // const milestoneId = localStorage.getItem("milestoneId");
  // const { data: project_based_task_names } =
  //   useFetchGetAllProjectBasedTaskNamesQuery();
  // //console.log("milestone_task_name", project_based_task_names);
  // const { data: project_based_issue_names } =
  //   useFetchGetAllProjectBasedIssueNamesQuery();
  // //console.log("project_based_issue_names", project_based_issue_names);
  const [selectedUsers, setSelectedUsers] = useState(login_user_id);
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  const { data: project_based_users } =
    useFetchGetAllProjectBasedUserNameListQuery(selectedProjectId, {
      skip: !selectedProjectId,
    });
  const { data: manager_list, refetch: manager_list_refresh } =
    useFetchGetallManagersQuery();
  const { data: project_manager } =useFetchGetManagerByProjectQuery(selectedProjectId, {
      skip: !selectedProjectId,
    });
  const project_manager_id = project_manager?.user_id;
  const { role: login_user_role } = login_user;
  const { data: usersInProjects } = useFetchGetallUserListQuery();
  //console.log("usersInProjects :", usersInProjects);
  // const { data: project_based_task_names } =
  //   useFetchGetAllProjectBasedTaskNamesQuery(selectedUsers);
  // const { data: project_based_issue_names } =
  //   useFetchGetAllProjectBasedIssueNamesQuery(selectedUsers);
  // const { data: all_projects, isLoading: projects_loading } =
    useFetchGetallProjectsQuery();

  const extractedUsers = usersInProjects
    ? usersInProjects.map((userWrapper) => userWrapper)
    : [];
  //console.log("usersInProjects extractedUsers:", extractedUsers);
  const {
    data: user_accessed_project,
    isLoading: project_loading,
    refetch: user_accessed_project_refetch,
  } = useFetchUserAccessedProjectsQuery();

  const {
    data: project_based_issue_names,
    refetch: project_based_issue_name_refetch,
  } = useFetchuserbasedIssuesQuery({
    user_id: selectedUsers,
    project_id: selectedProjectId,
  });

  const {
    data: project_based_task_names,
    refetch: project_based_task_name_refetch,
  } = useFetchuserbasedTasksQuery({
    user_id: selectedUsers,
    project_id: selectedProjectId,
  });
  // console.log("user_accessed_project :", project_based_task_names);
  //console.log("user_accessed_project  task:", project_based_task_names);

  const {
    handleSubmit,
    control,
    watch,
    setValue,
    setError,
    clearErrors,
  } = useForm({
    defaultValues: {
      date: currentDate,
      owner: login_user_id,
      taskName: "",
      billingType: "BILLABLE",
      Notes: "",
      startHour: "",
      startMinutes: "",
      startAmPm: "",
      endHour: "",
      endMinutes: "",
      fullTimeLog: "",
      endAmPm: null,
      OtherLogEntries: "",
      project_id: null,
      timesheet_type: "REGULAR",
      reported_manager_id: project_manager_id || null,
    },
  });

  const formatTime = (hour, minute, amPm) => {
    if (!hour || !minute || !amPm) return null;
    const isPM = amPm === "PM";
    const formattedHour = isPM
      ? hour === "12"
        ? "12"
        : String(Number(hour) + 12).padStart(2, "0")
      : hour === "12"
        ? "00"
        : hour.padStart(2, "0");
    return `${formattedHour}:${minute}`;
  };
  const textareaRef = useRef();

  useEffect(() => {
    if (showGenaralLog && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [showGenaralLog]); // Only run when this toggles

  // const startTime = formatTime(selectedHour, selectedMinutes, selectedAmPm);
  // const endTime = formatTime(
  //   selectedEndHour,
  //   selectedEndMinute,
  //   selectedEndAmPm
  // );
  useEffect(() => {
    //console.log("selected_user_id :", selectedUsers);
    project_based_issue_name_refetch();
    user_accessed_project_refetch();
    project_based_task_name_refetch();
  }, [selectedUsers, selectedProjectId]);
  useEffect(() => {
    manager_list_refresh();
  }, []);

  // Pre-fill form when opened for Copy & Edit
  useEffect(() => {
    // if (!prefillData) return;
        if (prefillData) {
      // Date from pre-fill
      if (prefillData.Date || prefillData.log_date) {
        const pDate = prefillData.Date || prefillData.log_date;
        setValue("date", dayjs(pDate));
      }

      // Project
      if (prefillData.parentId) {
        setValue("project_id", prefillData.parentId);
        setSelectedProjectId(prefillData.parentId);
      }

      // Billing type
      if (prefillData.billingType) {
        setValue("billingType", prefillData.billingType);
      }

      // Notes
      if (prefillData.dashBoard) {
        setValue("Notes", prefillData.dashBoard);
      }

      // Timesheet type (REGULAR or OT)
      if (prefillData.timesheet_type) {
        setValue("timesheet_type", prefillData.timesheet_type);
      }

      // Reported manager for OT
      if (prefillData.reported_manager_id) {
        setValue("reported_manager_id", prefillData.reported_manager_id);
      }
      
      // Owner (User)
      if (prefillData.owner_id) {
        setSelectedUsers(prefillData.owner_id);
        setValue("owner", prefillData.owner_id);
      }

      // Task / Issue / General Log pre-fill
      if (prefillData.task_id) {
        setTaskOrIssue("task");
        setValue("taskName", prefillData.task_id);
        
        // Only auto-update if we are NOT editing an existing record with a pre-filled billing type
        setSelectedID(prefillData.task_id);
        setShowGenaralLog(false);
      } else if (prefillData.issue_id) {
        setTaskOrIssue("issue");
        
        // Only auto-update if we are NOT editing an existing record with a pre-filled billing type
        setValue("taskName", prefillData.issue_id);
        setSelectedID(prefillData.issue_id);
        setShowGenaralLog(false);
      } else {
        const logTitle = prefillData.other_log_entries || prefillData.user || "";
        if (logTitle) {
          setValue("OtherLogEntries", logTitle);
          setShowGenaralLog(true);
        }
      }

      // Time period: start_time / end_time (24h format e.g. "09:30")
      if (prefillData.start_time && prefillData.end_time) {
        const parseTime24 = (t) => {
          const [h, m] = t.split(":").map(Number);
          const ampm = h >= 12 ? "PM" : "AM";
          const hour12 = h % 12 || 12;
          return {
            hour: String(hour12).padStart(2, "0"),
            minute: String(m).padStart(2, "0"),
            ampm,
          };
        };
        const start = parseTime24(prefillData.start_time);
        const end = parseTime24(prefillData.end_time);
        setSelectedHour(start.hour);
        setSelectedMinutes(start.minute);
        setSelectedAmPm(start.ampm);
        setSelectedEndHour(end.hour);
        setSelectedEndMinute(end.minute);
        setSelectedEndAmPm(end.ampm);
        setShowDailyLog(false); // use start/end time mode
      } else if (prefillData.logHourse) {
        // Hours-only mode
        setValue("fullTimeLog", prefillData.logHourse);
        setFullTimeLog(prefillData.logHourse);
        setShowDailyLog(true);
      }
      
      // }, [prefillData]);
          } else {
      // Default to the current view's date if adding a new entry
      setValue("date", dayjs());
    }
  }, [prefillData, fromDate, setValue]);

  useEffect(() => {
    // if (project_manager_id) {
    if (project_manager_id && !prefillData?.reported_manager_id) {
      setValue("reported_manager_id", project_manager_id);
    }
    // }, [project_manager_id, setValue]);
  }, [project_manager_id, setValue, prefillData]);
  const onError = (errors) => {
    console.log("❌ Form validation errors:", errors);
  };
  const onSubmit = async (data) => {
    //console.log("Form Data:", data);

    const startTime = formatTime(selectedHour, selectedMinutes, selectedAmPm);
    const endTime = formatTime(
      selectedEndHour,
      selectedEndMinute,
      selectedEndAmPm,
    );
    if (!showDailyLog) {
      // Check if start time and end time are equal
      if (startTime === endTime) {
        console.error("Start time or end time is missing or invalid.");
        toast.error("Start time and end time cannot be the same.");
        return;
      }
    }

    // Define payload based on the value of showDailyLog
    const payload = {
      log_date: data.date ? dayjs(data.date).format("YYYY-MM-DD") : null,
      billing_type: data.billingType,
      notes: data.Notes,
      owner_id: data.owner,
      project_id: isModule ? data.project_id : project_id,

      timesheet_type: data.timesheet_type,
      reported_manager_id: data.reported_manager_id,
    };
    if (!showGenaralLog) {
      if (taskOrIssue === "task") {
        payload.task_id = data.taskName;
      } 
       if (taskOrIssue === "issue") {
        payload.issue_id = data.taskName;
      }
    } else {
      payload.other_log_entries = data.OtherLogEntries;
    }
    if (isDetail && isTaskOrIssue === "task") {
      payload.task_id = TaskOrIssueId;
    }
    // If showDailyLog is true, send fullTimeLog, else send start_time and end_time
    if (showDailyLog) {
      const validLog = ValidDailyLog(fullTimeLog);
      if (!validLog) return; // Stop execution if validation fails
      payload.hours_in_text = validLog;
    } else {
      payload.start_time = startTime; // Send start time if showDailyLog is false
      payload.end_time = endTime; // Send end time if showDailyLog is false
    }
    //console.log("Payload to API:", payload);
    //console.log("Full time:", fullTimeLog);

    try {
      setLoading(true);
      let response;
      // Editing an existing log is not a "new log saved" - only adds get the utilisation popup.
      const isUpdate = Boolean(!isDetail && prefillData && (prefillData.timeLogId || prefillData.id));
      if (!isDetail) {
        if (prefillData && (prefillData.timeLogId || prefillData.id)) {
          response = await postResource(
            updatePath || "timesheet",
            "update",
            prefillData.timeLogId || prefillData.id,
            payload
          );
        } 
        else {
          response = await postdatas("timesheet", "add", payload);
        }
      } 
      else if (isDetail && isTaskOrIssue === "task") {
        response = await addData("task/timelog", TaskOrIssueId, payload);
      } 
      else if (isDetail && isTaskOrIssue === "issue") {
        response = await addData("issue/timelog", TaskOrIssueId, payload);
      } 
      else if (isDetail && isTaskOrIssue === "milestone-task") {
        response = await addData( "milestones/task/timelog", TaskOrIssueId, payload,);
      }
      else if (isDetail && isTaskOrIssue === "milestone-issue") {
        response = await addData( "milestones/issue/timelog", TaskOrIssueId, payload,);
      }

      //console.log("API Response:", response);
      onApply(payload);
      if (response) {
        toast.success(response.message);
        dispatch(apiSlice.util.invalidateTags(["Timesheet"]));
        refetchList();
        if (!isUpdate) notifyTimeLogSaved(payload, { onAddAnother });
        //console.log("items :", data);
      }
    }
    catch (error) {
      // console.error("Error adding subtask log hours:", error);
      toast.error(error.message);
    }
    finally {
      setLoading(false);
    }
  };

  const formattedTaskOptions =
    taskOrIssue === "task"
      ? formatTaskOptions(project_based_task_names)
      : formatIssueOptions(project_based_issue_names);
  useEffect(() => {
  //   setValue("taskName", ""); // Reset task selection
  // }, [selectedUsers, setValue]);
  
    // Reset task selection only if not pre-filling an existing log
    if (!prefillData) {
      setValue("taskName", ""); 
    }
  }, [selectedUsers, setValue, prefillData]);

  useEffect(() => {
    // Don't set taskName errors when in general log mode
    if (showGenaralLog) {
      clearErrors("taskName");
      return;
    }

    if (taskOrIssue === "task" && formattedTaskOptions?.length === 0) {
      setError("taskName", { message: "No tasks available for this user" });
    } 
    else if (taskOrIssue === "issue" && formattedTaskOptions?.length === 0) {
      setError("taskName", { message: "No issues available for this user" });
    } 
    else {
      clearErrors("taskName");
    }
  }, [
    showGenaralLog, // ← add this to dependencies
    project_based_task_names,
    project_based_issue_names,
    taskOrIssue,
    setError,
    clearErrors,
    formattedTaskOptions,
  ]);
  // auto complete with hours
  const onNameChange = (value) => {
    //console.log("task_or_issue_changed :", value);
    setTaskOrIssue(value);
  };
  //console.log("setSelectedID :", selectedID);

  const { data: taskDatas, } = useFetchViewTaskByIDQuery(
    selectedID ?? skipToken,
  );

  //console.log("setSelectedID_task datas :", taskDatas);
  // console.error("setSelectedID  task datas :", taskerror);
  useEffect(() => {
    // if (taskDatas && taskDatas.billing_type) {

        // Only auto-update if we are NOT editing an existing record with a pre-filled billing type
    if (taskDatas && taskDatas.billing_type && !(prefillData && prefillData.billingType)) {
      setValue("billingType", taskDatas.billing_type, { shouldValidate: true });
    }
  // }, [taskDatas, setValue]);
  
        // Only auto-update if we are NOT editing an existing record with a pre-filled billing type
    }, [taskDatas, setValue, prefillData]);
  const generalLogRef = useRef(null);
  const timesheet_type_watch = watch("timesheet_type");
  console.log("timesheet_type_watch :", timesheet_type_watch);
  useEffect(() => {
    if (showGenaralLog && generalLogRef.current) {
      generalLogRef.current.focus();
    }
  }, [showGenaralLog]);

  return (
    <div className="">
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3 tems-center">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack />
            Add Time Log
          </div>
        </button>
      </div>
      
      <div className="bg-white px-4 py-3">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit, onError)}>
            <div>
              <div className="row mb-3">
                {project_loading ? (
                  <Loader />
                ) : (
                  <>
                    {isModule && (
                      <div className="col-md-12">
                        <label htmlFor="project_id" className="form-label">
                          Project name <span className="errorMsg">*</span>
                        </label>
                        <Controller
                          name="project_id"
                          control={control}
                          rules={{ required: "Project field is required" }}
                          render={({
                            field: { onChange, value },
                            formState: { errors },
                          }) => (
                            <>
                              <Autocomplete
                                id="project_id"
                                // disabled={Boolean(prefillData)}  // disable for project name edit
                                options={
                                  Array.isArray(user_accessed_project)
                                    ? user_accessed_project.filter((project) => {
                                        const status = (
                                          project?.status_name ||
                                          project?.project_status ||
                                          project?.status ||
                                          ""
                                        )
                                          .toString()
                                          .toLowerCase();
                                        return status !== "completed";
                                      })
                                    : []
                                }
                                getOptionLabel={(option) => option?.title}
                                value={
                                  user_accessed_project?.find(
                                    (user) => user?.project_id === value,
                                  ) || null
                                }
                                loading={project_loading}
                                onChange={(event, newValue) => {
                                  if (newValue) {
                                    if (Array?.isArray(newValue)) {
                                      toast.error(
                                        "You can select only one project."
                                      );
                                    } else {
                                      onChange(newValue?.project_id);
                                      setSelectedProjectId(
                                        newValue?.project_id,
                                      ); // Set selected user ID
                                    }
                                  } else {
                                    onChange(null);
                                    setSelectedProjectId(null); // Reset selected user ID
                                  }
                                }}
                                renderOption={(props, option, { selected }) => (
                                  <li
                                    {...props}
                                    className="d-flex align-items-center mb-2"
                                  >
                                    <Checkbox
                                      style={{ marginRight: 8 }}
                                      checked={selected}
                                    />
                                    <strong>{option.title}</strong>
                                  </li>
                                )}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Select project"
                                  />
                                )}
                              />
                              <span className="errorMsg">
                                {errors?.project_id?.message}
                              </span>
                            </>
                          )}
                        />
                      </div>
                    )}
                  </>
                )}
              </div>

              {selectedProjectId && (
                <>
                  <div className="row mb-3">
                    {!isDetail && (
                      <div>
                        {!showGenaralLog ? (
                          <div className="mb-2">
                            <label
                              className="d-flex align-items-center gap-2 mb-2"
                              variant="subtitle1"
                            >
                              <span
                                value="task"
                                style={{
                                  cursor: "pointer",
                                  textDecoration:
                                    taskOrIssue === "task"
                                      ? "underline"
                                      : "none",
                                  textDecorationColor:
                                    taskOrIssue === "task"
                                      ? " rgb(1, 144, 122)"
                                      : "none",
                                  color:
                                    taskOrIssue === "task"
                                      ? " rgb(1, 144, 122)"
                                      : "lightgrey",

                                  fontWeight: "bold",
                                }}
                                onClick={() => onNameChange("task")}
                              >
                                Tasks
                              </span>
                              /
                              <span
                                value="issue"
                                style={{
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                  textDecoration:
                                    taskOrIssue === "issue"
                                      ? "underline"
                                      : "none",
                                  textDecorationColor:
                                    taskOrIssue === "issue"
                                      ? " rgb(1, 144, 122)"
                                      : "none",
                                  color:
                                    taskOrIssue === "issue"
                                      ? " rgb(1, 144, 122)"
                                      : "lightgrey",
                                }}
                                onClick={() => onNameChange("issue")}
                              >
                                Issues
                              </span>
                              <span className="errorMsg">*</span>
                            </label>
                            <Controller
                              name="taskName"
                              control={control}
                              shouldUnregister={true}
                              rules={{
                                required: !showGenaralLog
                                  ? "Task or issue name is required"
                                  : false,
                              }}
                              render={({
                                field: { onChange, value },
                                formState: { errors },
                              }) => (
                                <>
                                  {(taskOrIssue === "task" &&
                                    project_based_task_names) ||
                                    (taskOrIssue === "issue" &&
                                      project_based_issue_names) ? (
                                    <Autocomplete
                                      options={formattedTaskOptions}
                                      getOptionLabel={(option) => option.title}
                                      groupBy={null} // Custom grouping handled manually
                                      // disableCloseOnSelect
                                      filterOptions={customFilterOptions}
                                      value={
                                        formattedTaskOptions.find(
                                          (opt) => opt.task_id === value,
                                        ) || null
                                      }
                                      onChange={(_, newValue) => {
                                        const selectedId = newValue?.task_id;
                                        onChange(selectedId);
                                        setSelectedID(selectedId);
                                      }}
                                      isOptionEqualToValue={(option, value) =>
                                        option.task_id === value.task_id
                                      }
                                      renderOption={(
                                        props,
                                        option,
                                        { selected },
                                      ) =>
                                        option.isHeader ? (
                                          <li
                                            {...props}
                                            style={{
                                              fontWeight: "bold",
                                              opacity: 0.8,
                                              pointerEvents: "none",
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "8px",
                                            }}
                                          >
                                            {option.type === "milestone" ? (
                                              <img
                                                src={milestoneImage}
                                                alt="milestone"
                                                width={20}
                                                height={20}
                                              />
                                            ) : option.type === "task_list" ? (
                                              <img
                                                src={taskImage}
                                                alt="task list"
                                                width={16}
                                              />
                                            ) : option.type === "issue" ? ( // ✅ Add this to show issue image in "Issues" header
                                              <img
                                                src={issueImage}
                                                alt="issue"
                                                width={16}
                                              />
                                            ) : null}
                                            {option.title}
                                          </li>
                                        ) : (
                                          <li
                                            {...props}
                                            className="d-flex align-items-center mb-1 custom-autocomplete-option py-2"
                                          >
                                            <Checkbox
                                              style={{
                                                // marginRight: 8,
                                                marginLeft: "50px",
                                              }}
                                              checked={selected}
                                            />
                                            {/* Icon for each task or issue */}
                                            {option.type === "issue" ? (
                                              <img
                                                src={issueImage}
                                                alt="issue"
                                                width={16}
                                                height={16}
                                                style={{ marginRight: 8 }}
                                              />
                                            ) : option.type === "task" ? (
                                              <img
                                                src={taskImage}
                                                alt="task"
                                                width={16}
                                                height={16}
                                                style={{ marginRight: 8 }}
                                              />
                                            ) : null}
                                            <span>
                                              <strong>{option.title}</strong>
                                            </span>
                                          </li>
                                        )
                                      }
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          placeholder="Select task or issue"
                                        />
                                      )}
                                    />
                                  ) : (
                                    <Loader />
                                  )}

                                  <span className="errorMsg">
                                    {errors?.taskName?.message}
                                  </span>
                                </>
                              )}
                            />
                          </div>

                        ) : (
                          <div className="col-md-12 pb-3">
                            <label
                              htmlFor="OtherLogEntries"
                              className="form-label"
                            >
                              Other log entries{" "}
                              <span className="errorMsg">*</span>
                            </label>
                            <Controller
                              name="OtherLogEntries"
                              control={control}
                              rules={{
                                required: showGenaralLog
                                  ? "General log is required"
                                  : false,
                                validate: showGenaralLog
                                  ? (value) =>
                                    value.trim() !== "" ||
                                    "General log cannot be empty or just spaces"
                                  : undefined,
                              }}
                              render={({ field, fieldState: { error } }) => (
                                <>
                                  <TextareaAutosize
                                    {...field}
                                    minRows={4}
                                    maxRows={6}
                                    placeholder="Enter general log"
                                    className="textAreaField"
                                    ref={(el) => {
                                      field.ref(el);
                                      textareaRef.current = el;
                                    }}
                                  />

                                  {error && (
                                    <span className="errorMsg">
                                      {error.message}
                                    </span>
                                  )}
                                </>
                              )}
                            />
                          </div>
                        )}

                        {!hideGeneralLog && (
                          <p
                            onClick={() => {
                              setShowGenaralLog((prev) => {
                                const newValue = !prev;
                                if (newValue) {
                                  // Going to General Log → clear taskName
                                  setValue("taskName", undefined);
                                } else {
                                  // Going to Task/Issue → clear OtherLogEntries
                                  setValue("OtherLogEntries", "");
                                }
                                return newValue;
                              });
                            }}
                            className="enterHourse"
                          >
                            {!showGenaralLog
                              ? "enter general log "
                              : "task / issue"}
                          </p>
                        )}
                      </div>
                    )}

                    <div className="col-md-6 mb-3">
                      <label htmlFor="date" className="form-label">
                        Date <span className="errorMsg">*</span>
                      </label>
                      <div className=" d-flex  flex-column w-100 ">
                        <Controller
                          name="date"
                          defaultValue={currentDate}
                          control={control}
                          // rules={{ required: "Date is required" }}
                          render={({ field /* fieldState: { error } */ }) => {
                            return (
                              <>
                                <MobileDatePicker
                                  {...field}
                                  inputRef={dateInputRef} // Attach ref to DatePicker
                                  onChange={(date) => field.onChange(date)}
                                  value={field.value || currentDate}
                                  format="DD/MM/YYYY"
                                  disableFuture
                                  renderInput={(params) => (
                                    <input
                                      className="form-control"
                                      {...params}
                                    />
                                  )}
                                />
                                {/* {error && <p className="errorMsg">{error.message}</p>} */}
                              </>
                            );
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="owner" className="form-label">
                        Owner <span className="errorMsg">*</span>
                      </label>
                      <FormControl fullWidth>
                        <Select
                          labelId="owner-label"
                          value={selectedUsers} // Bind value to state
                          id="owner"
                          onChange={(e) => {
                            const newValue = e.target.value;
                            //console.log("New selected user:", newValue);
                            setSelectedUsers(newValue); // Update state
                            setValue("owner", newValue); // Update form field
                          }}
                          IconComponent={ExpandMore}
                        >
                          <MenuItem value={login_user_id}>
                            {`${login_user_name}(You)`}
                          </MenuItem>
                          {(login_user_role === "ADMIN" ||
                            login_user_role === "MANAGER") &&
                            project_based_users?.map((user) => (
                              <MenuItem key={user.user_id} value={user.user_id}>
                                {user.name}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </div>

                    {/* <DailyLog /> */}
                    {showDailyLog && (
                      <div className="col-md-6">
                        <label htmlFor="fullTimeLog" className="form-label">
                          Daily Log <span className="errorMsg">*</span>
                        </label>
                        <Controller
                          name="fullTimeLog"
                          control={control}
                          rules={{
                            required: "Daily log hours feild is required ",
                          }}
                          defaultValue="0:00"
                          render={({ field, fieldState: { error } }) => {
                            if (error && fullTimeRef.current) {
                              fullTimeRef.current.focus();
                            }
                            return (
                              <>
                                <TextField
                                  {...field}
                                  variant="outlined"
                                  inputProps={{ pattern: "^\\d{1,2}:\\d{2}$" }}
                                  fullWidth
                                  placeholder="HH:MM"
                                  ref={fullTimeRef}
                                  onChange={(e) => {
                                    field.onChange(e);
                                    //console.log(e.target.value);
                                    setFullTimeLog(e.target.value);
                                  }}
                                />
                                {error && (
                                  <p className="errorMsg">{error.message}</p>
                                )}
                              </>
                            );
                          }}
                        />
                      </div>
                    )}

                    {!showDailyLog && (
                      <div className="col-md-12 mt-1">
                        <label htmlFor="fullTimeLog" className="form-label">
                          Daily Log <span className="errorMsg">*</span>
                        </label>
                        <div className="row">
                          <div className="col-6">
                            <span className="lightText">From</span>
                            <div className="row">
                              <div className="col-12 col-lg-4">
                                <div className="autoCompleteTime">
                                  <Autocomplete
                                    options={hourOptions}
                                    value={selectedHour}
                                    onChange={(event, newValue) =>
                                      setSelectedHour(newValue)
                                    }
                                    disableClearable
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant="outlined"
                                        name="startHour"
                                        sx={{
                                          "& .MuiInputBase-root": {
                                            height: "36px",
                                          },
                                          "& input": { padding: "8px" },
                                        }}
                                      />
                                    )}
                                  />
                                </div>
                              </div>

                              <div className="col-12 col-lg-4">
                                <div className="autoCompleteTime">
                                  <Autocomplete
                                    options={minutesOptions}
                                    value={selectedMinutes}
                                    onChange={(event, newValue) =>
                                      setSelectedMinutes(newValue)
                                    }
                                    disableClearable
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant="outlined"
                                        name="startMinute"
                                        sx={{
                                          "& .MuiInputBase-root": {
                                            height: "36px",
                                          },
                                          "& input": { padding: "8px" },
                                        }}
                                      />
                                    )}
                                  />
                                </div>
                              </div>

                              <div className="col-12 col-lg-4">
                                <div className="autoCompleteTime">
                                  <Autocomplete
                                    options={amPmOptions}
                                    value={selectedAmPm}
                                    disableClearable
                                    onChange={(event, val) =>
                                      setSelectedAmPm(val)
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant="outlined"
                                        name="startAmPm"
                                        sx={{
                                          "& .MuiInputBase-root": {
                                            height: "36px",
                                          },
                                          "& input": { padding: "8px" },
                                        }}
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-6">
                            <span className="lightText">To</span>
                            <div className="row">
                              <div className="col-12 col-lg-4">
                                {/* <label className="form-label">To</label> */}
                                <div className="autoCompleteTime">
                                  <Autocomplete
                                    options={hourOptions}
                                    value={selectedEndHour}
                                    disableClearable
                                    onChange={(event, val) =>
                                      setSelectedEndHour(val)
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant="outlined"
                                        name="endHour"
                                        sx={{
                                          "& .MuiInputBase-root": {
                                            height: "36px",
                                          },
                                          "& input": { padding: "8px" },
                                        }}
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                              
                              <div className="col-12 col-lg-4">
                                <div className="autoCompleteTime">
                                  <Autocomplete
                                    options={minutesOptions}
                                    value={selectedEndMinute}
                                    disableClearable
                                    onChange={(event, newValue) =>
                                      setSelectedEndMinute(newValue)
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant="outlined"
                                        name="endMinutes"
                                        sx={{
                                          "& .MuiInputBase-root": {
                                            height: "36px",
                                          },
                                          "& input": { padding: "8px" },
                                        }}
                                      />
                                    )}
                                  />
                                </div>
                              </div>

                              <div className="col-12 col-lg-4">
                                <div className="autoCompleteTime">
                                  <Autocomplete
                                    options={amPmOptions}
                                    value={selectedEndAmPm}
                                    disableClearable
                                    onChange={(event, val) =>
                                      setSelectedEndAmPm(val)
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant="outlined"
                                        name="endAmPm"
                                        sx={{
                                          "& .MuiInputBase-root": {
                                            height: "36px",
                                          },
                                          "& input": { padding: "8px" },
                                        }}
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* enter  hours */}
                    <div className="col-md-4">
                      <p
                        className="enterHourse"
                        onClick={() => setShowDailyLog(!showDailyLog)}
                      >
                        {!showDailyLog ? "enter hours" : "set start & end time"}
                      </p>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <label htmlFor="timesheetType" className="form-label">
                          Timesheet Type <span className="errorMsg">*</span>
                        </label>
                        <Controller
                          name="timesheet_type"
                          control={control}
                          rules={{ required: "Type field is required" }}
                          render={({ field, fieldState: { error } }) => {
                            return (
                              <div>
                                <RadioGroup
                                  row
                                  value={field.value}
                                  onChange={(e) => {
                                    field.onChange(e.target.value);
                                  }}
                                >
                                  <FormControlLabel
                                    value="REGULAR"
                                    control={<Radio />}
                                    label="Regular"
                                    checked={field.value === "REGULAR"}
                                  />
                                  <FormControlLabel
                                    value="OT"
                                    control={<Radio />}
                                    label="OT"
                                    checked={field.value === "OT"}
                                  />
                                </RadioGroup>
                                {error && (
                                  <p className="errorMsg">{error.message}</p>
                                )}
                              </div>
                            );
                          }}
                        />
                      </div>

                      {timesheet_type_watch === "OT" && (
                        <div className="col-md-6">
                          <label
                            htmlFor="reported_manager_id"
                           className="form-label"
                          >
                            Manager<span className="text-rgbr-red"> *</span>
                          </label>
                          <div className="d-flex  flex-column w-100">
                            <FormControl fullWidth>
                              <Controller
                                name="reported_manager_id"
                                control={control}
                                rules={{
                                  required: "Manager field is required",
                                }}
                                render={({
                                  field: { onChange, value },
                                  formState: { errors },
                                }) => (
                                  <div>
                                    <Autocomplete
                                      id="reported_manager_id"
                                      options={
                                        Array.isArray(manager_list)
                                          ? manager_list
                                          : []
                                      }
                                      getOptionLabel={(option) => option.name}
                                      // value={
                                      //   manager_list?.find(
                                      //     (user) => user.user_id === value
                                      //   ) || null
                                      // }
                                      value={
                                        manager_list?.find(
                                          (user) => user.user_id === value,
                                        ) || null
                                      }
                                      onChange={(event, newValue) => {
                                        if (newValue) {
                                          if (Array.isArray(newValue)) {
                                            toast.error(
                                              "You can select only one user.",
                                            );
                                          } else {
                                            onChange(newValue.user_id);
                                          }
                                        } else {
                                          onChange(null);
                                        }
                                      }}
                                      renderOption={(
                                        props,
                                        option,
                                        { selected },
                                      ) => (
                                        <li
                                          {...props}
                                          className="d-flex align-items-center mb-2"
                                        >
                                          <Checkbox
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                          />
                                          <strong>{option.name}</strong>
                                        </li>
                                      )}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          fullWidth
                                          placeholder="Select Manager"
                                        />
                                      )}
                                    />
                                    <span className="errorMsg">
                                      {errors?.reported_manager_id?.message}
                                    </span>
                                  </div>
                                )}
                              />
                            </FormControl>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <label htmlFor="billingType" className="form-label">
                          Billing Type <span className="errorMsg">*</span>
                        </label>
                        <Controller
                          name="billingType"
                          control={control}
                          rules={{ required: "Billing Type field is required" }}
                          render={({ field, fieldState: { error } }) => {
                            const isTaskSelected = taskOrIssue === "task";
                            const selectedTaskId = watch("taskName"); // 👈 get selected task from form
                            const apiBillingType =
                              taskDatas?.billing_type || "";

                            // Disable only if:
                            // - NOT in general log mode
                            // - task is selected
                            // - there's a selected task ID
                            // - API has billing_type
                            const shouldDisable =
                              !showGenaralLog &&
                              isTaskSelected &&
                              !!selectedTaskId &&
                              !!apiBillingType;
                            return (
                              <div>
                                <RadioGroup
                                  row
                                  // value={
                                  //   shouldDisable ? apiBillingType : field.value
                                  // }
                                  
        // Only auto-update if we are NOT editing an existing record with a pre-filled billing type
                                   value={field.value}
                                  onChange={(e) => {
                                    // Allow changing only if not disabled
                                    if (!shouldDisable)
                                      field.onChange(e.target.value);
                                  }}
                                >
                                  <Tooltip 
                                    title={shouldDisable ? `This task is set as ${field.value?.toUpperCase() === "NON-BILLABLE" ? "Non-Billable" : "Billable"}, so it cannot be modified.` : ""} 
                                    arrow 
                                    disableHoverListener={!shouldDisable}
                                  >
                                    <span>
                                      <FormControlLabel
                                        sx={
                                          shouldDisable
                                            ? {
                                                cursor: "not-allowed !important",
                                                "& .MuiFormControlLabel-label": {
                                                  cursor: "not-allowed !important",
                                                },
                                                "& .MuiRadio-root": {
                                                  cursor: "not-allowed !important",
                                                },
                                              }
                                            : {}
                                        }
                                        value="BILLABLE"
                                        control={
                                          <Radio
                                            disabled={shouldDisable ? true : false}
                                          />
                                        }
                                        label="BILLABLE"
                                    // checked={
                                    //   shouldDisable
                                    //     ? apiBillingType === "BILLABLE"
                                    //     : field.value === "BILLABLE"
                                    // }
                                    
        // Only auto-update if we are NOT editing an existing record with a pre-filled billing type
                                    checked={field.value === "BILLABLE"}
                                      />
                                    </span>
                                  </Tooltip>
                                  <Tooltip 
                                    title={shouldDisable ? `This task is set as ${field.value?.toUpperCase() === "NON-BILLABLE" ? "Non-Billable" : "Billable"}, so it cannot be modified.` : ""} 
                                    arrow 
                                    disableHoverListener={!shouldDisable}
                                  >
                                    <span>
                                      <FormControlLabel
                                        sx={
                                          shouldDisable
                                            ? {
                                                cursor: "not-allowed !important",
                                                "& .MuiFormControlLabel-label": {
                                                  cursor: "not-allowed !important",
                                                },
                                                "& .MuiRadio-root": {
                                                  cursor: "not-allowed !important",
                                                },
                                              }
                                            : {}
                                        }
                                        value="NON-BILLABLE"
                                        control={
                                          <Radio
                                            disabled={shouldDisable ? true : false}
                                          />
                                        }
                                        label="NON-BILLABLE"
                                    // checked={
                                    //   shouldDisable
                                    //     ? apiBillingType === "NON-BILLABLE"
                                    //     : field.value === "NON-BILLABLE"
                                    // }
                                    
        // Only auto-update if we are NOT editing an existing record with a pre-filled billing type
                                     checked={field.value === "NON-BILLABLE"}
                                      />
                                    </span>
                                  </Tooltip>
                                </RadioGroup>
                                {error && (
                                  <p className="errorMsg">{error.message}</p>
                                )}
                              </div>
                            );
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-12 paddingBtn">
                      <label htmlFor="Notes"className="form-label">
                        Notes <span className="errorMsg">* </span>
                      </label>
                      <Controller
                        name="Notes"
                        control={control}
                        rules={{
                          required: "Notes field is required",
                          validate: (value) => {
                            const stripped = value
                              .replace(/<(.|\n)*?>/g, "")
                              .trim();
                            return (
                              stripped.length > 0 ||
                              "Notes field cannot be empty"
                            );
                          },
                        }}
                        render={({
                          field: { ref, onChange, value },
                          fieldState: { error },
                        }) => (
                          <div>
                            <ReactQuill
                              theme="snow"
                              onChange={onChange}
                              value={value}
                            />
                            {error && (
                              <p className="errorMsg">{error.message}</p>
                            )}
                          </div>
                        )}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="bg-white position-absolute w-100 bottom-0 py-3">
              <div className="d-flex justify-content-left mt-3">
                <button
                  type="submit"
                  className="add_btn me-3"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <BtnLoader />
                    </>
                  ) : prefillData && (prefillData.timeLogId || prefillData.id) ? (
                    "Update"
                  ) : (
                    "Add"
                  )}
                </button>

                <button
                  type="button"
                  className="cancel_btn"
                  disabled={loading}
                  onClick={onCancel}
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};

export const CommonTimesheetFilter = ({
  view_type,
  refetchList,
  onApply,
  onClear,
  onCancel,
  project_span,
  from_date,
  to_date,
  ismodule,
  filterPath,
  groupBy,
}) => {
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  //console.log("login_user in pproject:", login_user);
  const {
    role: login_user_role,
    name: login_user_name,
    id: login_user_id,
  } = login_user;
  // const [selectedUsers, setSelectedUsers] = useState(login_user_id);
  // const [selectedProjectId, setSelectedProjectId] = useState(null);
  const filterdata = sessionStorage.getItem("timesheet_filter");
  const sessionDatas = JSON.parse(filterdata);
  const [selectedUsers, setSelectedUsers] = useState( sessionDatas?.owner_id || login_user_id, );
  const [selectedProjectId, setSelectedProjectId] = useState( sessionDatas?.project_id || null, );
  const { id } = useParams();
  const [taskOrIssue, setTaskOrIssue] = useState("task");
  const [selectedID, setSelectedID] = useState();
  // const { data: UserNameOptions } =
  //   useFetchGetAllProjectBasedUserNameListQuery(selectedProjectId);
  const { data: UserNameOptions, refetch: user_refetch_module } = useFetchGetallUserListQuery();
  const userNameList = UserNameOptions?.map((user) => ({ id: user.user_id, title: user.name}));
  const {
    data: projectBasedUserNameOptions,
    refetch: project_based_user_refetch,
  } = useFetchGetAllProjectBasedUserNameListQuery(
    ismodule ? selectedProjectId : id,
    {
      skip: ismodule && !selectedProjectId,
    },
  );
  // const userNameList = projectBasedUserNameOptions?.map((user) => ({
  //   id: user.user_id,
  //   title: user.name,
  // }));
  const projectBasedUserNameList = Array.isArray(projectBasedUserNameOptions)
    ? projectBasedUserNameOptions.map((user) => ({
      id: user.user_id,
      title: user.name,
    }))
    : [];
  const UserNameOptionList = ismodule
    ? selectedProjectId
      ? projectBasedUserNameList
      : userNameList
    : projectBasedUserNameList;
  // console.log("user list data :", data);
  // console.log("user list data 1 :", UserNameOptions);

  // const [inputValue, setInputValue] = useState("");

  localStorage.getItem("project_id");
  //console.log("add log hours id", id);
  //console.log("project_based_user_names :", userNameList);
  // const { data: project_based_task_names, isLoading: task_name_loading } =
  //   useFetchGetAllProjectBasedTaskNamesQuery(selectedProjectId);
  // //console.log("milestone_task_name", project_based_task_names);
  // const { data: project_based_issue_names, isLoading: issue_name_loading } =
  //   useFetchGetAllProjectBasedIssueNamesQuery(selectedProjectId);
  // const {
  //   data: project_based_issue_names,
  //   refetch: project_based_issue_name_refetch,
  //   isLoading: issue_name_loading,
  // } =
   useFetchuserbasedIssuesQuery({
    user_id: selectedUsers,
    project_id: selectedProjectId,
  });

  // const {
  //   data: project_based_task_names,
  //   refetch: project_based_task_name_refetch,
  //   isLoading: task_name_loading,
  // } = 
  useFetchuserbasedTasksQuery({
    user_id: selectedUsers,
    project_id: selectedProjectId,
  });

  //console.log("project_based_issue_names", project_based_issue_names);
  //console.log("useparams id : ", id);
  const [loading, setLoading] = useState(false);

  //console.log("login_user role in project:", login_user_role);
  const { data: user_accessed_project, refetch: project_refetch } =
    useFetchUserAccessedProjectsQuery();
  //console.log("user_accessed_project :", user_accessed_project);
  // const filterdata = sessionStorage.getItem("timesheet_filter");
  // const sessionDatas = JSON.parse(filterdata);

  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      Users: sessionDatas?.owner_id || [],
      // Tasks: "",
      // Issues: "",
      // StartDate:
        // project_span === "project_span"

        StartDate: sessionDatas?.from_date
        ? dayjs(sessionDatas.from_date, "YYYY-MM-DD")
        : project_span === "project_span"
          ? null
          : from_date
            ? dayjs(from_date, "YYYY-MM-DD")
            : null,

      // EndDate:
        // project_span === "project_span"
              EndDate: sessionDatas?.to_date
        ? dayjs(sessionDatas.to_date, "YYYY-MM-DD")
        : project_span === "project_span"
          ? null
          : to_date
            ? dayjs(to_date, "YYYY-MM-DD")
            : null,

      billingType: sessionDatas?.billing_type || "",
      createdBy: sessionDatas?.added_by || "",
      project_id: sessionDatas?.project_id || null,
      // timesheet_type: "",
      timesheet_type: sessionDatas?.timesheet_type || "",
    },
  });

  const onSubmit = async (data) => {
    setLoading(true);
    // console.log("data_names filter_requested_data+response:", data);
    sessionStorage.setItem("letest_filters", JSON.stringify(data));
    const requestedData = {
      view_type: view_type,
      project_span: project_span,
      timesheet_type: data.timesheet_type,
      // from_date: from_date,
      // to_date: to_date,
      added_by: data.createdBy,
      // owner_id: JSON.stringify(data.Users), // Ensure it's an array
      owner_id: data.Users, // Ensure it's an array
      billing_type: data.billingType,
      project_id: ismodule ? data.project_id : id,
      from_date: data.StartDate
        ? format(new Date(data.StartDate), "yyyy-MM-dd")
        : null,
      to_date: data.EndDate
        ? format(new Date(data.EndDate), "yyyy-MM-dd")
        : null,
      groupBy: groupBy,
      // ...(taskOrIssue === "task"
      //   ? { task_id: selectedID }
      //   : { issue_id: selectedID }),
    };
    //console.log("filter_requested_data+response  data :", requestedData);

    try {
      const response = await filterEntities(
        filterPath,
        // id,
        requestedData,
      );
      if (response.session_data) {
        //console.log("filter response :", response.session_data);
        const { key, value } = response.session_data;
        sessionStorage.setItem(key, JSON.stringify(value));
      }
      if (response) {
        onApply(response);
        // JSON.stringify(sessionStorage.setItem("timesheet_filter", response));
        // sessionStorage.setItem("timesheet_filter", JSON.stringify(response));
        sessionStorage.setItem(
          "timesheet_filter",
          JSON.stringify(requestedData),
        );
        if (response.time_logs && response.time_logs.length > 0) {
          toast.success("Timesheet filter applied successfully!");
        }

        // refetchList();
      }
    } 
    catch (error) {
      console.error("Error filtering tasks:", error);
      toast.error(error.message);
      onCancel();
    } 
    finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    // reset();
    reset({
      Users: [],
      StartDate:
        project_span === "project_span"
          ? null
          : from_date
            ? dayjs(from_date, "YYYY-MM-DD")
            : null,
      EndDate:
        project_span === "project_span"
          ? null
          : to_date
            ? dayjs(to_date, "YYYY-MM-DD")
            : null,
      billingType: "",
      createdBy: "",
      project_id: null,
      timesheet_type: "",
    });
    setSelectedID(null);
    setSelectedUsers([]);
    setSelectedProjectId(null);
    onClear?.();
  };
  useEffect(() => {
    project_refetch();
    user_refetch_module();
    if (!ismodule || (ismodule && selectedProjectId)) {
      project_based_user_refetch();
    }
  }, []);

  const onNameChange = (value) => {
    //console.log("task_or_issue_changed :", value);
    setTaskOrIssue(value);
  };

  return (
    <div>
      {/* Header Section */}
      <div className="d-flex align-items-center  bg-white justify-content-between px-4 py-3">
        {/* <button onClick={onCancel} className="R_btn "> */}
        <button
          type="button"
          onClick={onCancel}
          className="R_btn"
        >
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack />
            Filter
          </div>
        </button>
        <div>
          <button
            type="button"
            onClick={handleClear}
            className="R_btn tex-tgba-red clear-filter-btn"
          >
            Clear Filter
          </button>
        </div>
      </div>

      {/* Filter Form */}
      <div className="bg-white px-4 py-3">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row mb-3">
              {ismodule && (
                <div className="col-md-12">
                  <label htmlFor="project_id" className="form-label">
                    Project name
                  </label>
                  <Controller
                    name="project_id"
                    control={control}
                    // rules={{ required: "Project field is required" }}
                    render={({
                      field: { onChange, value },
                      formState: { errors },
                    }) => (
                      <>
                        <Autocomplete
                          id="project_id"
                          options={
                            Array.isArray(user_accessed_project)
                              ? user_accessed_project
                              : []
                          }
                          getOptionLabel={(option) => option.title}
                          value={
                            user_accessed_project?.find(
                              (user) => user.project_id === value,
                            ) || null
                          }
                          onChange={(event, newValue) => {
                            if (newValue) {
                              if (Array.isArray(newValue)) {
                                toast.error("You can select only one project.");
                              } else {
                                onChange(newValue.project_id);
                                setSelectedProjectId(newValue.project_id); // Set selected user ID
                              }
                            } else {
                              onChange(null);
                              setSelectedProjectId(null); // Reset selected user ID
                            }
                          }}
                          renderOption={(props, option, { selected }) => (
                            <li
                              {...props}
                              className="d-flex align-items-center mb-2"
                            >
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              <strong>{option.title}</strong>
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select project"
                            />
                          )}
                        />
                      </>
                    )}
                  />
                </div>
              )}
            </div>

            <>
              <div className="g-3 row">
                <div className="col-md-12 mt-3">
                  <label htmlFor="Users" className="form-label">
                    Users
                  </label>
                  {login_user_role === "EMPLOYEE" ? (
                    <FormControl fullWidth>
                      <Select value={login_user_id}>
                        <MenuItem value={login_user_id}>
                          {login_user_name}
                        </MenuItem>
                      </Select>
                    </FormControl>
                  ) : (
                    <Controller
                      name="Users"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <Autocomplete
                          multiple
                          id="Users"
                          options={
                            Array.isArray(UserNameOptionList)
                              ? UserNameOptionList
                              : []
                          }
                          disableCloseOnSelect
                          getOptionLabel={(option) => option.title}
                          value={
                            (value || [])
                              .map((id) =>
                                UserNameOptionList?.find(
                                  (user) => user.id === id,
                                ),
                              )
                              .filter(Boolean) || []
                          }
                          onChange={(event, newValue) => {
                            const selectedTitles = newValue.map(
                              (user) => user.id,
                            );
                            onChange(selectedTitles);
                            setSelectedUsers(selectedTitles);
                          }}
                          renderOption={(props, option, { selected }) => (
                            <li
                              {...props}
                              className="d-flex align-items-center mb-2"
                            >
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              <strong>{option.title}</strong>
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField {...params} placeholder="Users" />
                          )}
                          ListboxProps={{
                            style: {
                              display: "grid",
                              gridTemplateColumns: "1fr 1fr",
                              gap: "8px",
                              paddingLeft: "0",
                            },
                          }}
                        />
                      )}
                    />
                  )}
                </div>

                <div className="col-md-6">
                  <label htmlFor="StartDate">Start date</label>
                  <div className=" d-flex  flex-column w-100 ">
                    <Controller
                      name="StartDate"
                      control={control}
                      render={({ field }) => (
                        <DatePicker
                          {...field}
                          format="DD/MM/YYYY"
                          disabled={project_span !== "project_span"}
                          onChange={(date) => field.onChange(date)}
                          renderInput={(params) => (
                            <TextField {...params} className="form-control" />
                          )}
                        />
                      )}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <label htmlFor="EndDate">End date</label>
                  <div className=" d-flex  flex-column w-100 ">
                    <Controller
                      control={control}
                      name="EndDate"
                      render={({ field }) => (
                        <DatePicker
                          {...field}
                          onChange={(date) => field.onChange(date)}
                          disabled={project_span !== "project_span"}
                          format="DD/MM/YYYY"
                          renderInput={(params) => (
                            <TextField {...params} className="form-control" />
                          )}
                        />
                      )}
                    />
                  </div>
                </div>
              </div>

              <div className="row mt-3 ">
                <div className="col-md-6">
                  <label className="form-label">Billing Type</label>
                  <Controller
                    name="billingType"
                    control={control}
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              selected
                            ) : (
                              <span className="lightText">Type</span>
                            )
                          }
                        >
                          <MenuItem value="BILLABLE">BILLABLE</MenuItem>
                          <MenuItem value="NON-BILLABLE">NON-BILLABLE</MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>

                {(login_user_role === "ADMIN" ||
                  login_user_role === "MANAGER") && (
                    <div className="col-md-6">
                      <label className="form-label">Created By</label>
                      <Controller
                        name="createdBy"
                        control={control}
                        disabled={login_user_role === "EMPLOYEE"}
                        render={({ field }) => (
                          <FormControl fullWidth>
                            <Select
                              {...field}
                              displayEmpty
                              renderValue={(selected) =>
                                selected ? (
                                  UserNameOptionList?.find(
                                    (user) => user.id === selected,
                                  )?.title
                                ) : (
                                  <span className="lightText">Select user</span>
                                )
                              }
                            >
                              {UserNameOptionList?.map((user, index) => (
                                <MenuItem key={index} value={user.id}>
                                  {user.title}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )}
                      />
                    </div>
                  )}
              </div>

              <div className="row mt-3 paddingBtn">
                <div className="col-md-6">
                  <label className="form-label">OT Status</label>
                  <Controller
                    name="timesheet_type"
                    control={control}
                    render={({ field }) => (
                      <FormControl size="small" fullWidth>
                        <Select
                          {...field}
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              selected
                            ) : (
                              <span className="lightText">Type</span>
                            )
                          }
                          input={<OutlinedInput />}
                        >
                          <MenuItem value="REGULAR">REGULAR</MenuItem>
                          <MenuItem value="OT">OT</MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>
              </div>
            </>
            
            {/* Footer Buttons */}
            <div className="bg-white position-absolute w-100 bottom-0 py-3">
              <div className="d-flex justify-content-left mt-3">
                <button
                  type="submit"
                  className="add_btn me-3"
                  disabled={loading}
                >
                  {/* {loading ? "Applying..." : "Apply"}
                   */}
                  {loading ? (
                    <>
                      <BtnLoader />
                    </>
                  ) : (
                    "Apply"
                  )}
                </button>

                <button
                  type="button"
                  disabled={loading}
                  className="cancel_btn"
                  onClick={onCancel}
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};
